module.exports = __webpack_public_path__ + "img/xcx.35ea19eb.png";